import { AnyAction } from "@reduxjs/toolkit";
import { ThunkDispatch } from "redux-thunk";
import { removeToken } from "../../redux/reducer/features/Auth/authSlice";
import { removeDmsData } from "../../redux/reducer/features/Integration/DmsSetupSlice";
import { removeCustomerDashboardCounts } from "../../redux/reducer/features/Dashboard/DashboardSlice";
import { removePortalSetting } from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { removeFilters } from "../../redux/reducer/features/Product/productSlice";
import { removeGridSetting } from "../../redux/reducer/features/App/AppGridSlice";

export const logout = () => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch(removeToken());
  dispatch(removeFilters());
  dispatch(removeGridSetting());
  dispatch(removeDmsData());
  dispatch(removeCustomerDashboardCounts());
  dispatch(removePortalSetting());
};
